<template>
  <div>
    <!--<vs-row vs-align="center"
            vs-type="flex"
            vs-justify="end"
            class="pb-4"
            vs-w="12">
      <vs-button @click="createNewContentPopup=true">Inhalt hinzufügen</vs-button>
    </vs-row>-->
    <div v-for="content in contents" :key="content.id" v-if="contents.length > 0">
      <ContentComponent :contentItem="content"/>
    </div>
    <!--   Create a new content-->
    <!--<vx-modal classContent="popup-example" title="Email schreiben" :active.sync="createNewContentPopup">
      <vs-row vs-type="flex" vs-align="center" vs-w="12">
        <div>
          <vs-input
            type="text"
            name="title"
            :disabled="!showTitle"
            icon-no-border
            icon-pack="feather"
            label-placeholder="Titel"
            v-model="title"
            :style="{color : titleColor}"
            class="w-full mt-6 mb-6"/>
          <vs-row vs-type="flex" class="mt-6 mb-6">
            <span class="pr-4">Titel Farbe</span>
            <input
              :disabled="!showTitle"
              type="color"
              @change="onColorChanged($event)"
              value="red">
          </vs-row>
          <vs-checkbox v-model="showTitle" class="mt-6 mb-6">Titel anziegen</vs-checkbox>
          <quill-editor style="width: 100%;" v-model="content" placeholder="Marktdetails"></quill-editor>
          <vs-checkbox v-model="deactivateContent" class="mt-6 mb-6">Inhalte deaktivieren</vs-checkbox>
          <vs-row vs-type="flex" vs-justify="end" class="pt-32" vs-w="12">
            <vs-button @click="showConfirmPopup=true" color="primary" type="filled">Erstellen</vs-button>
          </vs-row>
        </div>
      </vs-row>
      <vx-modal title="Sind Sie sicher?" :active.sync="showConfirmPopup">
        <p>Sind Sie sicher, dass Sie diese inhalt erstellen möchten?</p>
        <vs-row vs-type="flex" vs-justify="end" class="pt-12" vs-w="12">
          <vs-button @click="onConfirmPress" color="success" type="filled">Ja</vs-button>
        </vs-row>
      </vx-modal>
    </vx-modal>-->
    <!--   Create a new content-->
  </div>
</template>
<script>
  import ContentComponent from "./components/ContentComponent";
  import {quillEditor} from 'vue-quill-editor'
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'

  import {mapActions} from 'vuex'

  export default {
    components: {
      ContentComponent,
      quillEditor
    },
    data: function () {
      return {
        contentss: [
          {
            id: 1,
            title: 'hello',
            content: `<p>This is a test</p>`,
            isTitleShown: true,
            isContentDeactivated: false,
            titleColor: 'red'
          },
          {
            id: 2,
            title: 'hello numbner 1 ',
            content: `<p>This is a tlkalslksest</p>`,
            isTitleShown: true,
            isContentDeactivated: false,
            titleColor: 'blue'
          },
          {
            id: 3,
            title: 'world number one',
            content: `<p>This is a test from number one</p>`,
            isTitleShown: true,
            isContentDeactivated: false,
            titleColor: 'green',
          }
        ],
        contents: [],
        createNewContentPopup: false,
        content: '',
        title: '',
        showTitle: true,
        deactivateContent: false,
        titleColor: "#000000",
        showConfirmPopup: false
      }
    },
    mounted() {
      this.fetchHomeContent().then(() => {
          this.contents = this.$store.getters.getHomeContent
      })
    },
    methods: {
      ...mapActions(['fetchHomeContent']),
      onColorChanged(e) {
        this.titleColor = e.target.value
      },
      onConfirmPress() {
        this.showConfirmPopup = false
        this.createNewContentPopup = false
        this.$toast.success('Ihalt erstellet')
      }
    }
  }
</script>
